<style>
  .DownLoaded {
    background-color: #ff9595 !important;
  }

  .Uploaded {
    background-color: #a595ff !important;
  }

  .Exited {
    background-color: #95fff5 !important;
  }
</style>

<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Laboratory Check-in/Check-out</h5>
      <br />

      <div class="row">
        <div class="form-group col-md-12">
          <div class="table-responsive">
            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color:#399b89; color: white;">
                <tr>
                  <th></th>
                  <th>Current Month</th>
                  <th>Previous Month</th>
                  <th>Current Year</th>
                  <th>Previous Year</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="background-color: #399b89; color: white;font-weight: bolder">Check-ins</td>
                  <td>{{current_Month_DownloadLab}}</td>
                  <td>{{last_Month_DownloadLab}}</td>
                  <td>{{current_Year_DownloadLab}}</td>
                  <td>{{last_Year_DownloadLab}}</td>
                </tr>
                <tr>
                  <td style="background-color: #399b89; color: white;font-weight: bolder">Current Check-outs</td>
                  <td>{{current_Month_UploadLab}}</td>
                  <td>{{last_Month_UploadLab}}</td>
                  <td>{{current_Year_UploadLab}}</td>
                  <td>{{last_Year_UploadLab}}</td>
                </tr>
                <tr>
                  <td style="background-color: #399b89; color: white;font-weight: bolder">Previous Check-outs</td>
                  <td>{{current_Month_UploadLab_Late}}</td>
                  <td>{{last_Month_UploadLab_Late}}</td>
                  <td>{{current_Year_UploadLab_Late}}</td>
                  <td>{{last_Year_UploadLab_Late}}</td>
                </tr>
                <tr>
                  <td style="background-color: #399b89; color: white;font-weight: bolder;">Instruments Awaiting
                    Laboratory Check-in</td>
                  <td colspan="4">{{waitedDevice}}</td>
                </tr>
                <tr>

                  <td style="background-color: #399b89; color: white;font-weight: bolder;">Instruments Awaiting
                    Laboratory Check-out</td>
                  <td colspan="4">{{waitedexitedDevice}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Time Range (Reception Date)</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate_ReceiveDate" name="SubmitPeriodDate_ReceiveDate">
            <option value="1">Apply</option>
            <option value="0">Do Not Apply</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Start Date (Reception Date)</label>
          <input type="text" #datepickerInputStart_ReceiveDate placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart_ReceiveDate"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">End Date (Reception Date)</label>
          <input type="text" #datepickerInputEnd_ReceiveDate placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd_ReceiveDate"></ng-persian-datepicker>
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Time Range (Check-in Date)</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate_DownloadDate"
            name="SubmitPeriodDate_DownloadDate">
            <option value="1">Apply</option>
            <option value="0">Do Not Apply</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Start Date (Check-in)</label>
          <input type="text" #datepickerInputStart_DownloadDate placeholder="Type here..."
            class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart_DownloadDate"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">End Date (Check-in)</label>
          <input type="text" #datepickerInputEnd_DownloadDate placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd_DownloadDate"></ng-persian-datepicker>
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Time Range (Check-out Date)</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate_UploadDate" name="SubmitPeriodDate_UploadDate">
            <option value="1">Apply</option>
            <option value="0">Do Not Apply</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Start Date (Check-out)</label>
          <input type="text" #datepickerInputStart_UploadDate placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart_UploadDate"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">End Date (Check-out)</label>
          <input type="text" #datepickerInputEnd_UploadDate placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd_UploadDate"></ng-persian-datepicker>
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Customer Name </label>
          <input [(ngModel)]="Filter_customer" name="Filter_customer" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Status </label>
          <select class="custom-select" [(ngModel)]="Filter_Type_Lap">
            <option value="0">All</option>
            <option value="1">Not Checked In</option>
            <option value="2">Checked in but not checked out</option>
            <option value="3">Checked Out</option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <button *ngIf="!Procssing" type="button"
            (click)="ReadData_Lab(datepickerInputStart_ReceiveDate.value,datepickerInputEnd_ReceiveDate.value,datepickerInputStart_DownloadDate.value,datepickerInputEnd_DownloadDate.value,datepickerInputStart_UploadDate.value,datepickerInputEnd_UploadDate.value)"
            class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>

          <button *ngIf="!Procssing" type="button" routerLink="/LabDownloadDeviceForm" class="btn btn-success"
            style="margin-right: 5px;"><i class="fa  fa-cloud-download"></i> Laboratory Check-in </button>

          <button *ngIf="!Procssing" type="button" routerLink="/LabUploadDeviceForm" class="btn btn-warning"
            style="margin-right: 5px;"><i class="fa  fa-cloud-upload"></i> Laboratory Check-out </button>

          <button *ngIf="!Procssing" type="button" routerLink="/ColleagueDownload" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa fa-handshake-o"></i> Deliver Instrument to Colleague</button>

          <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
            style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <br>
      <br>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Instrument Name</th>
              <th>Instrument Code</th>
              <th>Instrument Serial Number</th>
              <th>Customer Name</th>
              <th>Receipt Number</th>
              <th>Reception Date</th>
              <th>Recipient</th>
              <th>Check-in Date</th>
              <th>Check-out Date</th>
              <th>Days to Receipt</th>
              <th>Days to Check-out</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Lab
            | paginate
                    : {
                        id: 'DataList_LabTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Lab).length
                      }
            " [ngClass]="{'DownLoaded': item.status===1,'Uploaded': item.status===2,'Exited': item.status===3}">
              <td>{{DataList_Lab.indexOf(item)+1}}</td>
              <td>{{item.device_name}}</td>
              <td>{{item.device_code}}</td>
              <td>{{item.device_serial}}</td>
              <td>{{item.customer}}</td>
              <td>{{item.code}}</td>
              <td>{{item.recieveLab}}</td>
              <td>
                <p *ngIf="item.contractor">{{item.contractor}}</p>
                <p *ngIf="!item.contractor">{{item.expert_Calibration}}</p>
              </td>
              <td>{{item.downloadLab}}</td>
              <td>{{item.uploadLab}}</td>
              <td>{{item.delay}}</td>
              <td>{{item.delay1}}</td>
              <td>
                <button
                  *ngIf="!item.contractor && item.uploadLab=='بدون تاریخ' && item.downloadLab!='بدون تاریخ' && !item.Processing"
                  type="button"
                  (click)="openModal_ExpertCalibration(templateExpertCalibration,DataList_Lab.indexOf(item))"
                  class="btn btn-danger" style="margin-right: 5px;"> Edit Calibration Technician <i class="fa fa-user-circle-o"></i>
                </button>

                <button *ngIf="item.downloadLab=='بدون تاریخ' && !item.Processing" type="button"
                  (click)="openModalParentMerge(templateParentMerge,item)" class="btn btn-warning"
                  style="margin-right: 5px;"> Attach Instrument
                </button>
                <button *ngIf="item.downloadLab=='بدون تاریخ' && !item.Processing && item.child.length>0" type="button"
                  (click)="openModalParentMergeChild(templateParentMergeChilde,item.child)" class="btn btn-success"
                  style="margin-right: 5px;"> Instrument List
                </button>

                <img *ngIf="item.Processing" src="assets/Loading.gif" style="width: 25px;" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_LabTable" nextLabel="Next" previousLabel="Previous"
      (pageChange)="page = $event"></pagination-controls>
  </div>
</div>

<ng-template #templateExit>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Equipment Exit without Calibration </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Upload.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> Click the field below before scanning the QR code. <i class="fa fa-arrow-down"></i>
        </label>
        <input [(ngModel)]="QRCodeInput" name="QRCodeInput" type="text"
          style="font-family: Arial, Helvetica, sans-serif;background-color: #dfdddd;" class="form-control EnglishClm"
          placeholder="Click here...">
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> Description </label>
        <input [(ngModel)]="Dsc_Exit" name="Dsc_Exit" type="text" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" (click)="QRCodeChangeExit()" type="submit" [disabled]="!QRCodeInput"
      class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Upload.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateParentMerge>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Attach Certificate </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ParentMerge.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> Row </label>
        <input [(ngModel)]="MergeIndex" (keyup)="MergeIndexKeyUp()" name="MergeIndex" type="number" class="form-control"
          placeholder="Type here...">
      </div>
    </div>
    <table *ngIf="SelectedLab_Merge_Merge &&SelectedLab_Merge_Merge.id>0"
      class="mb-0 table table-bordered table-3 text-center table-striped">
      <thead style="background-color: #489b39; color: white;">
        <tr>
          <th>Instrument Name</th>
          <th>Instrument Code</th>
          <th>Instrument Serial Number</th>
          <th>Customer Name</th>
          <th>Receipt Number</th>

        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{SelectedLab_Merge_Merge.device_name}}</td>
          <td>{{SelectedLab_Merge_Merge.device_code}}</td>
          <td>{{SelectedLab_Merge_Merge.device_serial}}</td>
          <td>{{SelectedLab_Merge_Merge.customer}}</td>
          <td>{{SelectedLab_Merge_Merge.code}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" (click)="MergeCalibration()" type="button" class="btn btn-success"
      style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_ParentMerge.hide()">Close</button>
  </div>
</ng-template>


<ng-template #templateParentMergeChilde>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Attach Certificate </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ParentMergeChilde.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="card-body">
    <table class="mb-0 table table-bordered table-3 text-center table-striped">
      <thead style="background-color: #489b39; color: white;">
        <tr>
          <th>#</th>
          <th>Instrument Name</th>
          <th>Instrument Code</th>
          <th>Instrument Serial Number</th>
          <th>Customer Name</th>
          <th>Receipt Number</th>

          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of SelectedLab_Merge_Merge_Child">
          <td>{{SelectedLab_Merge_Merge_Child.indexOf(item)+1}}</td>
          <td>{{item.device_name}}</td>
          <td>{{item.device_code}}</td>
          <td>{{item.device_serial}}</td>
          <td>{{item.customer}}</td>
          <td>{{item.code}}</td>

          <td>
            <button type="button" (click)="UnMergeCalibration(item)" class="btn btn-warning" style="margin-right: 5px;"> Delete Instrument </button>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
  <div class="modal-footer">
    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button type="button" class="btn btn-danger" (click)="modalRef_ParentMergeChilde.hide()">Close</button>
  </div>
</ng-template>


<ng-template #templateExpertCalibration>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Calibration Technician List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ExpertCalibration.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Last Name</label>
          <input [(ngModel)]="Filter_Familly" (keyup)="Change_Filter()" name="Filter_Familly" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Last Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_ExpertCalibration
            |filter:Filter_Familly:'familly'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 20,
                        currentPage: ExpertCalibrationpage,
                        totalItems: (DataList_ExpertCalibration
                        |filter:Filter_Familly:'familly'
                        ).length
                      }
            ">
              <td>{{DataList_ExpertCalibration.indexOf(item)+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.familly}}</td>
              <td (click)="Set_Selected_ExpertCalibration_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_ExpertCalibration" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_ExpertCalibration" type="button" (click)="ReadData_ExpertCalibration()"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_ExpertCalibration.hide()">Close</button>
  </div>
</ng-template>

<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>Instrument Name</th>
      <th>Instrument Code</th>
      <th>Instrument Serial Number</th>
      <th>Customer Name</th>
      <th>Receipt Number</th>
      <th>Reception Date</th>
      <th>Recipient</th>
      <th>Check-in Date</th>
      <th>Check-out Date</th>
      <th>Days to Receipt</th>
      <th>Days to Check-out</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Lab">
      <td>{{DataList_Lab.indexOf(item)+1}}</td>
      <td>{{item.device_name}}</td>
      <td>{{item.device_code}}</td>
      <td>{{item.device_serial}}</td>
      <td>{{item.customer}}</td>
      <td>{{item.code}}</td>
      <td>{{item.recieveLab}}</td>
      <td>
        <p *ngIf="item.contractor">{{item.contractor}}</p>
        <p *ngIf="!item.contractor">{{item.expert_Calibration}}</p>
      </td>
      <td>{{item.downloadLab}}</td>
      <td>{{item.uploadLab}}</td>
      <td>{{item.delay}}</td>
      <td>{{item.delay1}}</td>
    </tr>
  </tbody>
</table>
